import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/import-export-arten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="ImportExportTypes"
      returnRoute="/auswahlfelder/importExportTypes"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const ImportExportTypesRoute = Route;
